import type { ReactNode } from 'react'

export function PublicPageShell({
  association,
  children,
}: {
  association: { name: string }
  children: ReactNode
}) {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="border-b border-border bg-card">
        <div className="mx-auto flex h-16 max-w-5xl items-center gap-3 px-6">
          <div className="flex size-8 shrink-0 items-center justify-center rounded-md bg-primary text-body-sm font-semibold text-primary-foreground">
            {association.name.slice(0, 1)}
          </div>
          <span className="truncate text-body-sm font-medium">{association.name}</span>
        </div>
      </header>
      <main className="mx-auto w-full max-w-5xl px-6 py-8">{children}</main>
    </div>
  )
}

export function PublicNotFoundPage({ association }: { association: { name: string } }) {
  return (
    <PublicPageShell association={association}>
      <div className="mx-auto max-w-xl py-16 text-center">
        <h1 className="text-heading-sm font-semibold">Page not found</h1>
        <p className="mt-2 text-body-sm text-muted-foreground">
          The page you requested could not be found.
        </p>
      </div>
    </PublicPageShell>
  )
}
